import React from "react";
import Banner from "../Banner/Banner";
import Community from "../Community/Community";
import Courses from "../Courses/Courses";
import Footer from "../Footer/Footer";
import History from "../History/History";
import News from "../News/News";
import PrayerTime from "../Prayer-time/PrayerTime";
import Scholar from "../Scholar/Scholar";
import ScrollToSection from "../ScrollToSection/ScrollToSection";
import Services from "../Services/Services";
import Sura from "../Sura/Sura";

const Home = () => {
  return (
    <div>
      <ScrollToSection />

      <Banner />
      <PrayerTime />
      {/* <History /> */}
      <Scholar />
      <Courses />
      <Services />
      <Sura />
      <Community />
      {/* <News /> */}
    </div>
  );
};

export default Home;
